import { FC } from "react";
import { Link } from "react-router-dom";
import withPage from "../../components/Page";
import Section from "../../components/Section";
import { globalContent } from "../../config/content";
import styles from "./TermsAndConditions.module.scss";

const TermsAndConditions: FC = () => {
  return (
    <div className={styles.termsPage}>
      <Section bgColor="white" sectionClass={styles.legalSection}>
        <div className={styles.legalContainer}>
          <div className={styles.pageHeader}>
            <h1 className={styles.h1}>Terms & Conditions</h1>
            <p className={styles.leadText}>
              These Terms & Conditions govern your use of the Pulse website. By using this website, you agree to comply with these terms.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>About these terms</h2>
            <p className={styles.paragraph}>
              These terms apply to use of the Pulse marketing website.
            </p>
            <p className={styles.paragraph}>
              They do not constitute the terms governing use of the Pulse platform by customers.
            </p>
            <p className={styles.paragraph}>
              Separate agreements may apply where Pulse services or products are provided to customers.
            </p>
          </div>



          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Using this website</h2>
            <p className={styles.paragraph}>
              You may use the website for lawful purposes only. You must not:
            </p>
            <ul className={styles.list}>
              <li>Use the website in a way that breaches applicable laws or regulations.</li>
              <li>Attempt to gain unauthorised access to the website or its systems.</li>
              <li>Introduce malicious software or harmful code.</li>
              <li>Interfere with the operation, security or availability of the website.</li>
              <li>Use website content for unlawful, fraudulent or misleading purposes.</li>
            </ul>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Website content</h2>
            <p className={styles.paragraph}>
              Information on the website is provided for general information about Pulse and its services.
            </p>
            <p className={styles.paragraph}>
              Reasonable care is taken to keep information accurate and up to date, but information may change without notice.
            </p>
            <p className={styles.paragraph}>
              Website content should not be treated as professional, legal, financial, technical or other specialist advice unless explicitly stated.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Intellectual property</h2>
            <p className={styles.paragraph}>
              Unless otherwise stated, the website and its content are owned by or licensed to the relevant business.
            </p>
            <p className={styles.paragraph}>
              This includes text, branding, graphics, images, software and other materials.
            </p>
            <p className={styles.paragraph}>
              Users may view and use the website for its intended purpose. Content must not be reproduced, copied, distributed, modified or commercially exploited without appropriate permission, except where permitted by law.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Third-party links</h2>
            <p className={styles.paragraph}>
              The website may contain links to third-party websites or services provided for convenience or additional information.
            </p>
            <p className={styles.paragraph}>
              Pulse does not control third-party websites and is not responsible for their content, availability, security or privacy practices. Users should review the relevant third party's terms and privacy policy.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Website availability</h2>
            <p className={styles.paragraph}>
              Reasonable efforts may be made to keep the website available, but continuous or uninterrupted availability cannot be guaranteed.
            </p>
            <p className={styles.paragraph}>
              The website may occasionally be unavailable because of maintenance, updates, technical issues or circumstances outside reasonable control.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Liability</h2>
            <p className={styles.paragraph}>
              To the maximum extent permitted by law, we exclude liability for any loss or damage arising from your use of, or inability to use, the website, reliance on information provided through the website, or third-party websites linked from the website.
            </p>
            <p className={styles.paragraph}>
              Nothing in these terms attempts to exclude liability that cannot legally be excluded.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Privacy</h2>
            <p className={styles.paragraph}>
              Personal information collected through the website is handled in accordance with our <Link to="/privacy-policy" className={styles.link}>Privacy Policy</Link>.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Cookies</h2>
            <p className={styles.paragraph}>
              The website may use cookies or similar technologies where necessary. For more information, please see our <Link to="/cookie-policy" className={styles.link}>Cookie Policy</Link>.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Changes to these terms</h2>
            <p className={styles.paragraph}>
              These terms may be updated from time to time to reflect changes to the website, services or applicable legal requirements.
            </p>
            <p className={styles.paragraph}>
              The latest version will be published on this page.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Governing law</h2>
            <p className={styles.paragraph}>
              These Terms & Conditions are governed by and construed in accordance with the laws of England and Wales, and any disputes relating to these terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Contact us</h2>
            <p className={styles.paragraph}>
              If you have any questions about these Terms & Conditions, please visit our <Link to="/contact" className={styles.link}>Contact page</Link>.
            </p>
          </div>

          <div className={styles.lastUpdated}>
            Last updated: October 2026
          </div>
        </div>
      </Section>
    </div>
  );
};

export default withPage(TermsAndConditions)({
  meta: globalContent.seo.terms,
});
